module.exports = __webpack_public_path__ + "static/media/Music Note.4587d470.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Players/Music Note.jpg
// module id = 190
// module chunks = 0